<template>
    <div class="password">
        <el-input
            ref="password"
            :value="password"
            :placeholder="placeholder"
            type="password"
            :tabindex="tabindex"
            :maxlength="maxlength"
            :clearable="clearable"
            :show-password="showPassword"
            v-on="$listeners"
            @input="handleInput"
            @keyup.native="handleKeyUp"
            @blur="handleBlur"
        />
        <el-tooltip
            v-if="showTooltip"
            ref="tooltip"
            v-model="tooltip"
            content="大写锁定已打开"
            placement="right"
            manual
        ></el-tooltip>
    </div>
</template>

<script>
export default {
    name: 'SyPassword',
    model: {
        prop: 'password',
        event: 'change'
    },
    props: {
        /**
         * 密码值
         */
        password: {
            type: String,
            default: ''
        },
        /**
         * 占位符
         */
        placeholder: {
            type: String,
            default: '密码'
        },
        /**
         * tab键顺序
         */
        tabindex: {
            type: String,
            default: '0'
        },
        /**
         * 最大输入字符数
         */
        maxlength: {
            type: String,
            default: '6'
        },
        /**
         * 是够拥有清除按钮
         */
        clearable: {
            type: Boolean,
            default: true
        },
        /**
         * 是否拥有显示按钮
         */
        showPassword: {
            type: Boolean,
            default: true
        },
        /**
         * 是否拥有大写锁定提示
         */
        showTooltip: {
            type: Boolean,
            default: true
        }
    },
    data() {
        return {
            // 是否显示提示
            tooltip: false
        };
    },
    mounted() {
        // 修改tooltip参考对象
        this.$refs.tooltip.referenceElm = this.$refs.password.$el;
    },
    methods: {
        /**
         * 输入框获取焦点
         */
        focus() {
            this.$refs.password.focus();
        },
        /**
         * 处理输入事件
         * @param event
         */
        handleInput(event) {
            this.$emit('change', event);
        },
        /**
         * 处理按键弹起事件
         * @param e
         */
        handleKeyUp({ shiftKey, key } = {}) {
            if (key && key.length === 1) {
                if ((shiftKey && key >= 'a' && key <= 'z') || (!shiftKey && key >= 'A' && key <= 'Z')) {
                    this.tooltip = true;
                } else {
                    this.tooltip = false;
                }
            }
            if (key === 'CapsLock' && this.tooltip === true) {
                this.tooltip = false;
            }
        },
        /**
         * 处理失去焦点事件
         * @param e
         * @param type
         */
        handleBlur(e, type) {
            this[type] = false;
        }
    }
};
</script>
